// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customeTheme {
  background-color: transparent !important;
  width: 200px;
  padding: 0 !important;
  opacity: 1 !important;
  border: 0 !important;
  border-radius: 20px !important;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

.card {
  flex: 0 0 auto;
  margin-right: 3px;
}

.pop_card{
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/NewsStockSlider.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,8BAA8B;EAC9B,uLAAuL;AACzL;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uLAAuL;AACzL","sourcesContent":[".customeTheme {\n  background-color: transparent !important;\n  width: 200px;\n  padding: 0 !important;\n  opacity: 1 !important;\n  border: 0 !important;\n  border-radius: 20px !important;\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\n}\n\n.card {\n  flex: 0 0 auto;\n  margin-right: 3px;\n}\n\n.pop_card{\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
